import type { Component, Entity2D } from '../../odie';

import type { CageBlockProps } from '../defs/block';
import { CageBlockView } from '../views/blocks/CageBlockView';

// types
//-----------------------------------------------------------------------------
export type CageBlockComponentOptions = {
  props: CageBlockProps;
};

/*
    cage block component
*/
export class CageBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCage';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CageBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CageBlockComponentOptions): void {
    // create cage block view
    this.view = new CageBlockView(options.props);
  }
}
